import {useListView} from '../core/ListViewProvider'
import {FacilityListToolbar} from './FacilitieListToolbar'
import {FacilityListGrouping} from './FacilitieListGrouping'
import {FacilityListSearchComponent} from './FacilitiesListSearchComponent'

const FacilityListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <FacilityListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <FacilityListGrouping /> : <FacilityListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {FacilityListHeader}
